import { useNavigate } from "react-router-dom";
import UserIcon from "..//..//..//assets//user-icon.png";
import useAuth from "../../../hooks/useAuth";
import HttpHelper from "../../../helpers/Http/HttpHelper";
import { API_ROUTES } from "../../../constants/API_ROUTES";
import { ROUTES } from "../../../constants/Routes";
import { toast } from "react-toastify";

const UserNavOption = () => {
  const navigate = useNavigate();
  const { clearAuth, getAuth, getUser } = useAuth();

  const signOut = () => {
    console.log(getUser());
    HttpHelper.PostRequest({
      route: API_ROUTES.LOGOUT,
      token: getAuth()?.bearerToken,
      parameters: {
        user: getUser(),
      },
    })
      .then((res) => {
        if (res.status == 200) {
          clearAuth();
          navigate(ROUTES.AUTH);
          toast.success(" successfully logout !", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else if (res.status == 401) {
          clearAuth();
          navigate(ROUTES.AUTH);
          toast.success(" successfully logout !", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          toast.error("Unknown error !", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      })
      .catch((error) => {
        toast.error("Unknown error !", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };
  return (
    <>
      <div className="flex space-x-1">
        <div
          className="flex flex-row items-center gap-[0.6325rem] cursor-pointer"
          data-dropdown-toggle="user-icon-dropdown-menu"
        >
          <h2 className="font-lato text-[1rem] leading-normal hidden md:block font-bold">Ladányi Róbert</h2>
          <img src={UserIcon} alt="user icon" className="w-[2.625rem] rounded-full" />
        </div>

        <div
          className={`absolute hidden right-0 z-10 mt-2 w-36 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none`}
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="menu-button"
          id="user-icon-dropdown-menu"
          tabIndex="-1"
        >
          <div className="py-1" role="none">
            <div
              onClick={signOut}
              className="flex items-center gap-4 px-4 py-3 text-sm text-gray-700 cursor-pointer transition-all ease-in-out duration-100 hover:bg-[#e6eef0]"
            >
              Sign Out
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserNavOption;
